var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 13.333 16.667",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 11.667H10v1.666H3.333zm0-3.334H10V10H3.333zm5-8.333H1.667C.75 0 0 .75 0 1.667V15c0 .917.742 1.667 1.658 1.667h10.009c.916 0 1.666-.75 1.666-1.667V5zm3.334 15h-10V1.667H7.5v4.166h4.167z"
  })));
};
export default SvgFile;